import { useEffect, useRef } from 'react';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import './ConnectionStatus.css';

export default function ConnectionStatus({ status }) {
  const prev = useRef('connected');
  const warnRef = useRef(null);
  const errRef = useRef(null);
  const errTimerRef = useRef(null);

  useEffect(() => {
    toastr.options.progressBar = false;
    toastr.options.timeOut = 3000;
    toastr.options.tapToDismiss = false;

    const clearErrTimer = () => {
      if (errTimerRef.current) {
        clearTimeout(errTimerRef.current);
        errTimerRef.current = null;
      }
    };
    const clearWarning = () => {
      if (warnRef.current) {
        toastr.clear(warnRef.current, { force: true });
        warnRef.current = null;
      }
    };
    const clearError = () => {
      if (errRef.current) {
        toastr.clear(errRef.current, { force: true });
        errRef.current = null;
      }
    };

    if (status === 'reconnecting') {
      clearErrTimer();
      clearError();
      if (!warnRef.current) {
        warnRef.current = toastr.warning(
          'Попытка восстановления...',
          'Соединение потеряно.',
          { timeOut: 0, extendedTimeOut: 0, progressBar: false }
        );
      }
    } else if (status === 'disconnected') {
      clearWarning();
      clearErrTimer();
      errTimerRef.current = setTimeout(() => {
        if (prev.current !== 'connected' && status === 'disconnected' && typeof window !== 'undefined') {
          errRef.current = toastr.error(
            'Пожалуйста, перезагрузите страницу.',
            'Соединение с сервером не установлено.',
            {
              timeOut: 0,
              extendedTimeOut: 0,
              onclick: () => { if (typeof window !== 'undefined') window.location.reload(); }
            }
          );
        }
      }, 2000);
    } else if (status === 'connected') {
      clearErrTimer();
      clearWarning();
      clearError();
      if (prev.current !== 'connected') {
        toastr.success(' ', 'Соединение восстановлено', { timeOut: 2000 });
      }
    }

    prev.current = status;
    return () => {
      clearErrTimer();
    };
  }, [status]);

  return null;
}
